import { createStructuredSelector } from 'reselect';
import {
  ownerSelector,
  tagsSelector,
  notesSelector,
  propertiesSelector,
  ownerDetailFormSelector,
  ownerValidateSelector,
  ownerGroupsSelector,
  ownerLookupModalSelectionSelector,
} from '../../selectors/owner';

import {
  propertySelector,
  propertyDropdownsSelector,
} from '../../selectors/property';
import {
  viewOnlySelector,
} from '@modules/appraisal/selectors/global';

export default createStructuredSelector({
  formValues: ownerDetailFormSelector,
  notes: notesSelector,
  owner: ownerSelector,
  ownerValidate: ownerValidateSelector,
  ownerGroups: ownerGroupsSelector,
  property: propertySelector,
  properties: propertiesSelector,
  tags: tagsSelector,
  selectedOwner: ownerLookupModalSelectionSelector,
  dropdowns: propertyDropdownsSelector,
  viewOnly: viewOnlySelector,
});
